import axios from "axios";

export const state = {
    reportsavingperusers: [],
};

export const getters = {
    reportsavingperusers: state => state.reportsavingperusers,
};

export const mutations = {
    setReportSavingsPerUser(reportsavingperusers, newValue) { state.reportsavingperusers = newValue},
};

export const actions = {
    async fetchReportSavingsPerUser({ commit }) {
        await axios.get('/reportsavingperusers').then(res => {
            commit('setReportSavingsPerUser', res.data.savings)
        })
    },
    async filterReportSavingsPerUser({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportsavingperusers";
        await axios.post(url, formData).then((response) => {
            commit('setReportSavingsPerUser', response.data.savings)
        })
    },
};
